import request from '@/utils/request'

/**
 * 获取列表数据
 */
export const getConfigGroupLists = (data) => {
    return request({
        url: '/appkit/group/lists',
        params: data
    })
}

/**
 * 获取应用分组选项列表数据
 */
export const getAppkitGroupOptionLists = (data) => {
    return request({
        url: '/appkit/group/option/lists',
        params: data
    })
}

/**
 * 详情
 */
export const getAppkitGroupDetail = (id) => {
    return request({
        url: `/appkit/group/${id}`
    })
}

/**
 * 修改
 */
export const putAppkitGroup = (data) => {
    return request({
        url: '/appkit/group/manage',
        method: 'PUT',
        data
    })
}

/**
 * 添加
 */
export const addAppkitGroup = (data) => {
    return request({
        url: '/appkit/group/manage',
        method: 'POST',
        data
    })
}

/**
 * 开放应用分组-删除
 */
export const delAppkitGroup = (id) => {
    return request({
        url: `/appkit/group/${id}`,
        method: 'DELETE'
    })
}

// 批量启用
export const batchEnable = (data) => {
    return request({
        url: '/module/manage',
        method: 'PATCH',
        data: {
            method: 'batch_enable',
            data
        }
    })
}

// 批量禁用
export const batchDisable = (data) => {
    return request({
        url: '/module/manage',
        method: 'PATCH',
        data: {
            method: 'batch_disable',
            data
        }
    })
}

// 批量排序
export const batchSort = (data) => {
    return request({
        url: '/module/manage',
        method: 'PATCH',
        data: {
            method: 'batch_update_order',
            data
        }
    })
}
